import React, { useEffect } from "react";
import "@/App.css";
import { ReactLenis, useLenis } from "lenis/react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";

import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import CartDrawer from "./components/CartDrawer";
import DisclaimerBar from "./components/DisclaimerBar";

import Landing from "./pages/Landing";
import Cart from "./pages/Cart";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Account from "./pages/Account";
import Admin from "./pages/Admin";
import OrderSuccess from "./pages/OrderSuccess";

const Loader = () => (
  <div className="min-h-screen bg-[#050505] flex items-center justify-center">
    <div className="h-10 w-10 border-2 border-[#E6DFD4] border-t-transparent rounded-full animate-spin" />
  </div>
);

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <Loader />;
  if (user === false) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return children;
};

const ScrollManager = () => {
  const lenis = useLenis();
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, lenis]);
  return null;
};

function Shell() {
  return (
    <div className="App bg-[#050505] min-h-screen text-[#F5F5F5]">
      <div className="grain-overlay" />
      <ScrollManager />
      <Header />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/order/success" element={<ProtectedRoute><OrderSuccess /></ProtectedRoute>} />
        <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <DisclaimerBar />
      <Footer />
      <FloatingWhatsApp />
      <CartDrawer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
            <Shell />
            <Toaster position="bottom-center" theme="dark" toastOptions={{ style: { background: "#0D0D0D", border: "1px solid #222", color: "#F5F5F5" } }} />
          </ReactLenis>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
